import { Interest } from '@fund-base/types/types/types.types';
import { GooglePlace } from '../google/google-places.types';
import { SearchType } from '@fund-base/store/state/funds.state';

export enum HiddenFundsMode {
  ALL = 'all',
  EXCLUDE_HIDDEN = 'excludeHidden',
  ONLY_HIDDEN = 'onlyHidden',
}

export interface FiltersSearch {
  searchType?: SearchType;

  type?: { id: string }[];
  areaOfInterests?: Interest[];
  matchAllAreaOfInterests?: boolean; // true = AND logic (default), false = OR logic
  areaOfActivity?: { description?: string; viewport?: number[][] | null; place_id?: string }[];
  locationOfTheFund?: { description?: string; viewport?: number[][] | null; place_id?: string } | null;

  locationOfTheFundV2?: {
    country: (GooglePlace & { countryCode: string }) | null;
    state: GooglePlace | null;
    city: GooglePlace | null;
  };

  AreaOfActivityV2?: {
    country: (GooglePlace & { countryCode: string }) | null;
    state: GooglePlace | null;
    city: GooglePlace | null;
  };

  fundingRange?: Grants | string;
  textSearch?: string;
  email?: boolean;
  webSite?: boolean;
  monthsToApply?: { id?: string }[];
  phone?: boolean;
  newestFunds?: boolean;
  hiddenFundsMode?: HiddenFundsMode;
  limitations?: boolean;
  delegations?: boolean;
  sortBy?: string;
  searchAfter?: any[];
  pit?: string;
}

export class Grants {
  min?: string;
  max?: string;
}

export interface FundsFilter {
  categoryKey: string;
  properties: FundsFilterOption[];
}

export class FundsFilterOption {
  count: number = 0;
  key: string = '';
}

export class FundsSortingOption {
  value: string;
  text: string;
}

export class SearchQuery {
  _source?: string[];
  sort: number[];
  query: any;
  from: number;
  size: number;
}

export class SearchHistoryQuery {
  sort?: [{ _score?: string }, { updated_at?: string }, { fb_id?: string }];
  query: any;
}

export class SearchHistory {
  id?: number;
  search_query?: { bool?: { should?: { bool?: { must?: any[] } }[]; must?: { bool?: { must?: any[] } }[] } };
  sort?: [{ _score?: string }, { updated_at?: string }, { fb_id?: string }];
  results_count?: number;
  type?: { id?: string }[];
  areaOfInterests?: Interest[];
  areaOfActivity?: { description?: string; viewport?: number[][] | null; place_id?: string }[];
  locationOfTheFund?: { description?: string; viewport?: number[][] | null; place_id?: string };
  fundingRange?: string;
  textSearch?: string;
  email?: boolean;
  webSite?: boolean;
  monthsToApply?: { id?: string }[];
  created_at?: Date;
  phone?: boolean;
  newFunds?: boolean;
  limitations?: boolean;
  delegations?: boolean;
}
